<template>
  <div class="actions-menu-wrapper" data-app>
    <BbMenu
      v-model="showMenu"
      class="actions-menu"
      display-items="6"
      max-width="240px"
      min-width="240px"
      nudge-bottom="8"
      size="medium"
      is-offset-y
      alignment="bottom-left"
    >
      <template #menuActivator>
        <BbBtn
          :class="['open-actions-menu-button', { active: showMenu }]"
          size="x-small"
          type="icon"
          icon="menu-dots"
          icon-size="medium"
          icon-type="filled"
          no-background
        ></BbBtn>
      </template>

      <BbMenuItem
        v-for="(item, index) in items"
        :key="`action-item-${index}`"
        class="action-item"
        size="medium"
        @click="handleMenuItemClick(item.name)"
      >
        <TextBody :i18n-key="item.label"></TextBody>
      </BbMenuItem>
    </BbMenu>
  </div>
</template>

<script>
import { computed, ref } from 'vue';

import useCollections from '~/composables/useCollections';
import useModals from '~/composables/useModals';

import TextBody from '~/components/common/TextBody';

const ACTIONS_MENU = [
  {
    name: 'edit',
    label: 'common.edit',
  },
  {
    name: 'share',
    label: 'common.share',
  },
  {
    name: 'delete',
    label: 'common.delete',
  },
];

export default {
  name: 'ActionsMenu',
  components: { TextBody },
  props: {
    collection: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { removeCollection, isReadOnly } = useCollections();
    const { setCreateCollectionPopup, setSharedLinkCollectionPopup } = useModals();
    const showMenu = ref(false);
    const items = computed(() =>
      isReadOnly(props.collection)
        ? [
            {
              name: 'delete',
              label: 'common.delete',
            },
          ]
        : ACTIONS_MENU,
    );
    const handleMenuItemClick = (action) => {
      switch (action) {
        case 'edit':
          setCreateCollectionPopup({ open: true, collection: props.collection });
          break;
        case 'share': {
          setSharedLinkCollectionPopup({ open: true, collectionId: props.collection.collectionId });
          break;
        }
        case 'delete': {
          removeCollection(props.collection.collectionId);
          break;
        }
        default: {
          console.log('unknown action');
        }
      }
    };
    return {
      items,
      handleMenuItemClick,
      removeCollection,
      showMenu,
    };
  },
};
</script>

<style scoped lang="scss">
.actions-menu-wrapper {
  .action-item {
    color: $bb-primary-1 !important;
  }
}
</style>
